"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatNumber_1 = require("../formatNumber");
/**
 * Utilitná funkcia pre naformátovanie ceny
 * @param {number} - Číslo pre naformátovanie
 * @param {string} - Mena. Automaticky konvertuje "EUR" na "€" a "CZK" na "Kč"
 * @param {number} - Počet desatinných miest, na ktoré sa číslo zaokrúhli
 * @param {string} - Oddeľovač desatinných miest
 * @param {string} - Oddeľovač tisícov
 * @returns {string} - Naformátovaná cena
 * @example
 * ```javascript
 * import formatPrice from 'utilities/lib/formatPrice';
 * const price = 1234.543252;
 *
 * console.log(formatPrice(price)); // 1 234,54 €
 * console.log(formatPrice(price, 'USD', 4)); // 1 234,5433 USD
 * console.log(formatPrice(price, 'USD', 4, '.')); // 1 234.5433 USD
 * console.log(formatPrice(price, 'USD', 4, '.', '.')); // 1.234.5433 USD
 * ```
 */
function formatPrice(n, currency, c, d, t) {
    if (currency === void 0) { currency = 'EUR'; }
    if (c === void 0) { c = 2; }
    if (d === void 0) { d = ','; }
    if (t === void 0) { t = '\u00a0'; }
    if (currency === 'CZK') {
        return formatNumber_1.default(n, c, d, t) + " K\u010D";
    }
    else if (currency === 'EUR') {
        return formatNumber_1.default(n, c, d, t) + " \u20AC";
    }
    return formatNumber_1.default(n, c, d, t) + " " + currency;
}
exports.default = formatPrice;
